import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class WebformsFormConverter extends CmsConverterService<WebformsComponentData> {
  convertData (source: CmsComponent): WebformsComponentData {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      uid: source?.uid ?? '',
      previewId: source?.otherProperties?.previewId ?? '',
      form: {
        formUid: formData.form?.value?.uid ?? '',
        name: formData.form?.name ?? '',
        fd: formData.form?.value?.fd ?? '',
        lang: formData.form?.value?.lang ?? '',
        refs: formData.form?.value?.refs ?? '',
      }
    } as WebformsComponentData
  }
}

export const WEBFORMS_FORM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CmsComponent>>('WebformsFormConverter')

export interface WebformsComponentData extends ConvertedComponentData {
  form: WebformsFormData;
}

export interface WebformsFormData {
  formUid: string;
  name: string;
  fd: string;
  lang: string;
  refs: string;
}

export interface MarketingCloudParams {
  sapOutboundId: string | null;
  campaignSecurityToken: string | null;
}
